/**
 * TMR Required Chips directive
 *
 * @example
 * <md-chips tmr-required-chips="true"></md-chips>
 *
 * @namespace
 * @alias tmrRequiredChips
 * @type {ngDirective}
 */
function tmrRequiredChipsDirective($parse) {
  'ngInject'
  return {
    restrict: 'A',
    require: 'ngModel',
    link,
  }

  function link($scope, $element, $attr, $ctrl) {
    $scope.$watchCollection($attr.ngModel, (values, prevValues) => {
      let isRequired = $parse($attr.tmrRequiredChips)($scope)
      $ctrl.$setValidity('tmrRequiredChips', !isRequired || values.length > 0)
      if (values != prevValues) $ctrl.$setDirty()
    })
  }
}

export const directive = ['tmrRequiredChips', tmrRequiredChipsDirective]
